import {
  Flex,
  Heading,
  VStack,
  Text,
  Spacer,
} from '@chakra-ui/react';
import IntakeConfig from '../../../interfaces/IntakeConfig.interface';
import MultiselectField from '../form/MutiselectButtonField';

type Addon = NonNullable<IntakeConfig['plan']>['countries'][string]['periods'][number]['addons'][number];

const FormBuilder = ({ addons }: { addons?: Array<Addon> }) => {
  return (
    <VStack align="stretch" gap="2em" width="100%">
      {addons?.map(addon => <Addon addon={addon} key={addon.id} />)}
    </VStack>
  );
};

const controlTable = {
  multiselect: MultiSelect,
};

function MultiSelect({ addon }: { addon: Addon }) {
  // @ts-ignore
  return (
    <Flex direction="row" gap="0.5em" width="100%" wrap="wrap">
      {addon.options.map((o) => (
        <MultiselectField
          name={`addons.${addon.id}`}
          value={o.id}
          key={o.id}
          label={o.label}
          price={o.price}
          unit={o.unit}
          iconPosition="right"
        />
      ))}
    </Flex>
  );
}

const Addon = ({ addon }: { addon: Addon }) => {
  // @ts-ignore
  const Control = controlTable[addon.type];
  if (!Control) return null;
  return (
    <VStack align="start">
      <Heading size="md">{addon.label}</Heading>
      {addon.description && <Text>{addon.description}</Text>}
      <Spacer />
      <Control addon={addon} />
    </VStack>
  );
};

export default FormBuilder;
